import { render } from "./ArticlesView.vue?vue&type=template&id=ba7c43e8"
import script from "./ArticlesView.vue?vue&type=script&lang=js"
export * from "./ArticlesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__